import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  root: {
    width: 20,
    height: 20,
    objectFit: "contain",
  },
});
